import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { pdfjs } from "react-pdf";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import VerificationPage from "./components/VerificationPage";
import Login from "./Login";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

// Import new page components
import MainDashboard from "./pages/MainDashboard";
import DetailedDocumentDashboard from "./pages/DetailedDocumentDashboard";
import DocumentDetails from './pages/DocumentDetails';

console.log("[App] Initializing PDF.js worker");
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: fixed;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  }

  #root {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
`;

const AppContainer = styled.div`
  min-height: 100vh;
  background: #fff;
`;

const App = () => {
  console.log("[App] Component rendering");

  return (
    <AppContainer>
      <GlobalStyle />
      <Router>
        <AuthenticatedTemplate>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/dashboard" element={<MainDashboard />} />
            <Route path="/document/:documentId" element={<DetailedDocumentDashboard />} />
            <Route path="/verify/:documentId" element={<VerificationPage />} />
            <Route path="/login" element={<Navigate to="/dashboard" />} />
            <Route path="/document-details/:documentId" element={<DocumentDetails />} />
          </Routes>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Navigate to="/login" />} />
            <Route path="/document/:documentId" element={<Navigate to="/login" />} />
            <Route path="/verify/:documentId" element={<Navigate to="/login" />} />
            <Route path="/document-details/:documentId" element={<Navigate to="/login" />} />
          </Routes>
        </UnauthenticatedTemplate>
      </Router>
    </AppContainer>
  );
};

export default App;
